import { enhanceImage } from '../components/DualgsViewer/geminiImageEnhance.js'

export function downloadCanvasScreenshot(canvas, opts = {}) {
  if (!canvas) return
  const {
    width = canvas.width,
    height = canvas.height,
    prefix = 'screenshot',
  } = opts
  const link = document.createElement('a')
  link.download = `${prefix}_${width}x${height}_${Date.now()}.png`
  link.href = canvas.toDataURL('image/png')
  link.click()
}

// toDataURL is captured synchronously at the top, so callers can resize / re-render
// the canvas immediately after calling without affecting the captured pixels.
export async function aiEnhanceCanvas(canvas, opts = {}) {
  if (!canvas) throw new Error('aiEnhanceCanvas: canvas is required')
  const {
    width = canvas.width,
    height = canvas.height,
    prefix = 'enhanced',
    mimeType = 'image/png',
  } = opts

  const base64 = canvas.toDataURL(mimeType).split(',')[1]

  const { blob, text } = await enhanceImage(base64, mimeType)
  if (text) console.log('[Gemini]', text)

  const url = URL.createObjectURL(blob)
  try {
    const link = document.createElement('a')
    link.download = `${prefix}_${width}x${height}_${Date.now()}.png`
    link.href = url
    link.click()
  } finally {
    URL.revokeObjectURL(url)
  }
  return { text }
}
